import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "x-t-cell-date-editor x-cell-editor"
};
const _hoisted_2 = {
  key: 1,
  class: "x-cell-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_date_picker = _resolveComponent("a-date-picker");
  return $props.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass({
      'inner-border': true,
      'input-error': $props.error
    })
  }, [_createVNode(_component_a_date_picker, {
    format: $props.format,
    bordered: $setup.isFocused,
    value: $setup.date,
    style: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      padding: '1px 5px'
    },
    "onUpdate:value": $setup.handleUpdateValue,
    onBlur: $setup.handleBLur,
    onFocus: $setup.handleFocus
  }, {
    prefix: _withCtx(() => [_renderSlot(_ctx.$slots, "prefix")]),
    suffix: _withCtx(() => [_renderSlot(_ctx.$slots, "suffix")]),
    _: 3
  }, 8, ["format", "bordered", "value", "onUpdate:value", "onBlur", "onFocus"])], 2)])) : (_openBlock(), _createElementBlock("span", _hoisted_2, [_createElementVNode("span", {
    class: _normalizeClass({
      'input-error': !!$props.error
    })
  }, _toDisplayString($setup.text), 3)]));
}